import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac462ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode("คำสั่งคณะทำงานกลั่นกรองแผนงาน/โครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลเอกสารคำสั่งคณะทำงานกลั่นกรองแผนงาน/โครงการ ที่ต้องการแสดงบนหน้าเว็บไซต์")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommitteeTableComponent = _resolveComponent("CommitteeTableComponent")!
  const _component_CommitteeFormComponent = _resolveComponent("CommitteeFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary mb-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
        }, [
          _hoisted_4,
          _createTextVNode("เพิ่มคำสั่งคณะทำงานกลั่นกรองแผนงานฯ ")
        ]),
        _createVNode(_component_CommitteeTableComponent, { onEdit: _ctx.editClick }, null, 8, ["onEdit"])
      ])
    ]),
    _createVNode(_component_CommitteeFormComponent, {
      ref: "committeeForm",
      "committee-id": _ctx.selectedCommitteeId
    }, null, 8, ["committee-id"])
  ], 64))
}